import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NecUrl } from '../../model/url//url';
import { Observable } from 'rxjs';

@Injectable()
export class NecHealthInterface {
  constructor(private http: HttpClient) {
  }

  /**
   * è·åæå¡å¨å½åç¶æ
   */
  getServerHealthStatus(): Observable<any> {
    return this.http.get(NecUrl.SERVER_URL + '/server/health');
  }
}
